module.exports = __webpack_public_path__ + "static/NotoSans-BoldItalic.subset-4d02e70e21becaa4297669e417b4a4f5.otf";